document.addEventListener('DOMContentLoaded', function() {
    const variantSelector = document.querySelector('select[name="id"]'); // Adjust selector as needed
    const metafieldContainer = document.getElementById('selected-metafield');

    if (variantSelector) {
        variantSelector.addEventListener('change', function() {
            const selectedVariantId = variantSelector.value;
            const selectedMetafield = document.getElementById('metafield-' + selectedVariantId);
            
            if (selectedMetafield) {
                metafieldContainer.innerHTML = selectedMetafield.innerHTML;
            } else {
                metafieldContainer.innerHTML = '';
            }
        });

        // Trigger change event to show metafield for the initially selected variant
        variantSelector.dispatchEvent(new Event('change'));
    }
});
